import axiosInstance from "../plugins/axios";

export default function companyService() {


  const fetchContracts = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/contracts/${url}`
    );
  };
  const fetchContracts1400 = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/contracts/${url}`
    );
  };
  const fetchContracts01 = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/contracts1401/${url}`
    );
  };

  const fetchContracts02 = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/contracts1402/${url}`
    );
  };

  const fetchContracts03 = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/contracts1403/${url}`
    );
  };

  const fetchFactors = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/factors/${url}`
    );
  };
  const fetchOtherFactors = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/other-factors/${url}`
    );
  };
  const fetchRacks = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/racks/${url}`
    );
  };

  const fetchRacks403 = async data => {
    let url = '?';
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        if (value) {
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/racks403/${url}`
    );
  };

  return {
    fetchContracts,
    fetchFactors,
    fetchOtherFactors,
    fetchRacks,
    fetchContracts01,
    fetchContracts02,
    fetchContracts03,
    fetchContracts1400,
    fetchRacks403,
  }
}


